import type { ReactNode } from "react";

import type { User } from "../../../../models/User";
import type { WPApiBlock } from "../../../../models/WPContentBlock";
import type { WPProductConfig } from "../../../../models/WPProductConfig";
import type { ApiClient } from "../../../../utils/api/_makeApiClient";

export async function fetchStudentCompletedTests(
  apiClient: ApiClient,
  user: User | undefined,
  product: WPProductConfig | undefined,
  block: WPApiBlock,
): Promise<ReactNode | null> {
  if (!user || !product) {
    return null;
  }

  const [tests, { StudentCompletedTests }] = await Promise.all([
    apiClient.fetchStudentCompletedTests(user, product),
    import(
      "../../../components/blocks/StudentCompletedTests/StudentCompletedTests"
    ),
  ]);

  return <StudentCompletedTests model={block} tests={tests} />;
}
